import React, { Suspense, lazy, useEffect, useRef, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import useDemoBookingPrompt from './useDemoBookingPrompt';

const BookDemoModal = lazy(() => import('./BookDemoModal'));

const BRAND = '#2261a2';

const barSx = {
  position: 'fixed',
  top: { xs: 56, sm: 64 },
  left: 0,
  right: 0,
  zIndex: 1200,
  width: '100%',
  bgcolor: BRAND,
  color: '#fff',
  px: { xs: 1.5, sm: 2, md: 3 },
  py: { xs: 1, md: 1.1 },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: { xs: 1, sm: 1.5, md: 2 },
  flexWrap: 'wrap',
  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.18)',
};

const DemoBookingPrompt = () => {
  const { open, openPrompt, closePrompt, showBar } = useDemoBookingPrompt();
  const barRef = useRef(null);
  const [barHeight, setBarHeight] = useState(0);

  useEffect(() => {
    if (!showBar || !barRef.current) {
      setBarHeight(0);
      return undefined;
    }

    const updateHeight = () => {
      setBarHeight(barRef.current?.offsetHeight ?? 0);
    };

    updateHeight();
    const observer = new ResizeObserver(updateHeight);
    observer.observe(barRef.current);
    window.addEventListener('resize', updateHeight);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', updateHeight);
    };
  }, [showBar]);

  return (
    <>
      {open ? (
        <Suspense fallback={null}>
          <BookDemoModal open={open} onClose={closePrompt} />
        </Suspense>
      ) : null}
      {showBar && (
        <>
          <Box ref={barRef} sx={barSx}>
            <Typography
              sx={{ fontSize: { xs: '13px', md: '14px' }, fontWeight: 600, textAlign: 'center' }}
            >
              Want a personalised walkthrough of the B2B Barter Platform?
            </Typography>
            <Button
              variant="contained"
              onClick={openPrompt}
              sx={{
                bgcolor: '#fff',
                color: BRAND,
                textTransform: 'none',
                fontSize: { xs: '10px', md: '12px' },
                fontWeight: 700,
                borderRadius: '20px',
                px: 2.5,
                py: 0.1,
                boxShadow: 'none',
                '&:hover': { bgcolor: '#e9f1fb' },
              }}
            >
              Book a demo
            </Button>
          </Box>
          <Box aria-hidden sx={{ height: barHeight, flexShrink: 0 }} />
        </>
      )}
    </>
  );
};

export default DemoBookingPrompt;
